export const HOMEPAGE_URL = process.env.VUE_APP_HOMEPAGE_URL
export const BACKEND_URL = process.env.VUE_APP_BACKEND_URL
export const BASE_URL = process.env.VUE_APP_BASE_URL
export const LANGUAGE = process.env.VUE_APP_LANGUAGE
export const SENTRY_API = process.env.VUE_APP_SENTRY_API
export const COOKIE_DOMAIN = process.env.VUE_APP_VUE_APP_COOKIE_DOMAIN
export const ANONYMOUS_USER_PASSWORD = process.env.VUE_APP_ANONYMOUS_USER_PASSWORD
export const DEVELOPMENT_MODE = process.env.VUE_APP_DEVELOPMENT_MODE
export const MAINTENANCE_WINDOW = process.env.VUE_APP_MAINTENANCE_WINDOW
